import { render, staticRenderFns } from "./SolicitacoesAcesso.vue?vue&type=template&id=bf3c08cc"
import script from "./SolicitacoesAcesso.vue?vue&type=script&lang=js"
export * from "./SolicitacoesAcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports